import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';

import { withAuthentication } from './session';

import Navigation from './components/Navigation';
import ReactTooltip from 'react-tooltip';

import Create from './pages/Create';
import Edit from './pages/Edit';
import Home from './pages/Home';
import Analyze from './pages/Analyze';
import LogIn from './pages/LogIn';
import LogOut from './pages/LogOut';
import EULA from './pages/EULA';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import ViewSona from './pages/ViewSona';
import Admin from './pages/Admin';
// import SignUp from './pages/SignUp';

import * as ROUTES from './constants/routes';

const App = () => (
  <Router>
    <div className="App-container">
      <div className="Boy">
        <Navigation />
        <Switch>
          <Route exact path={ROUTES.LANDING} component={Home} />
          <Route path={ROUTES.LOG_IN} component={LogIn} />
          <Route path={ROUTES.LOG_OUT} component={LogOut} />
          <Route path={ROUTES.EULA} component={EULA} />
          <Route path={ROUTES.CREATE} component={Create} />
          <Route path={ROUTES.EDIT} component={Edit} />
          <Route path={ROUTES.ANALYZE} component={Analyze} />
          <Route path={ROUTES.VIEW_SONA} component={ViewSona} />
          <Route path={ROUTES.HOME} component={Home} />
          <Route path={ROUTES.PROFILE} component={Profile} />
          <Route path={ROUTES.ADMIN} component={Admin} />
          <Route component={NotFound} />
          <ReactTooltip place="top" effect="solid" />
        </Switch>
      </div>
    </div>
  </Router>
);

export default withAuthentication(App);
